import { nlpIntegration } from '@mi-front/api-clients';
import { useCallback, useState } from 'react';
import { usePostHogCaptureLiveTopics } from '../../hooks/usePostHogCaptureLiveTopics';

/**
 * Holds the selected topic for the detail view and derived state.
 * Returns selectedTopicId, setter, the selected topic object, whether detail view is active, and a back handler.
 * Captures topic_selected when the selection changes.
 */
export function useLiveTopicsSelection(topics: nlpIntegration.TopicOutDto[]) {
  const [selectedTopicId, setSelectedTopicIdState] = useState<string | null>(null);
  const capture = usePostHogCaptureLiveTopics();

  const setSelectedTopicId = useCallback(
    (topicId: string) => {
      const topic = topics.find((t) => t.id === topicId);
      capture('topic_selected', {
        source: 'panel',
        topic_id: topicId,
        category: topic?.category ?? undefined,
      });
      setSelectedTopicIdState(topicId);
    },
    [capture, topics],
  );

  const selectedTopic =
    selectedTopicId != null ? (topics.find((t) => t.id === selectedTopicId) ?? null) : null;
  const isDetailView = selectedTopic != null;

  const handleBack = () => setSelectedTopicIdState(null);

  return {
    selectedTopicId,
    setSelectedTopicId,
    selectedTopic,
    isDetailView,
    handleBack,
  };
}
